import { createModuleStateSelector } from '@americanexpress/travel-selectors';
import { MODULE_NAME } from '../constants/moduleConstants';

const getModuleState = createModuleStateSelector(MODULE_NAME);

export default getModuleState;
